import { css } from '@emotion/react';

const makeSolarMapStyles = ({ theme } = {}) => ({
  map: css({ width: '100%', height: 320, borderRadius: 8 }),
  unavailable: css({
    width: '100%',
    padding: 16,
    textAlign: 'center',
    color: theme?.mvf?.palette?.text?.secondaryTextColor,
  }),
});

export default makeSolarMapStyles;
